<template>
    <div id="poll">
        <highcharts ref="chart" :options="chartOptions" v-if="chartData"/>
        <FeedbackBox v-bind:message="selectedFeedback" v-if="selectedFeedback" />
    </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import FeedbackBox from '../FeedbackBox.vue'
export default {
  name: 'Poll',
  components: {
      highcharts: Chart,
      FeedbackBox
  },
  props: ['chartData', 'selectedOption', 'api', 'learnerId', 'programId', 'boosterId'],
  watch: {
      selectedOption: {
          immediate: true,
          handler() {
            if (!this.appliedSelection)
            {
                this.appliedSelection = true;
                this.chartData.seriesData[this.selectedOption - 1] += 1;
                if (this.api) {
                    this.api.post('/api/event', {
                        code: 304,
                        lid: this.learnerId,
                        pid: this.programId,
                        bid: this.boosterId,
                        submission: this.selectedOption,
                    })
                }
                
            }
            
          }
      }
  },
  computed: {
      selectedFeedback: function() {
          if (this.chartData.feedback.length >= (this.selectedOption - 1)) {
              return this.chartData.feedback[this.selectedOption - 1]
          }
          return null
      }
  },
  data() {
      return {
          appliedSelection: false,
          chartOptions: {
              chart: {
                type: 'column',
                marginLeft: 80,
                marginTop: 20,
                height: 400
              },
              reflow: false,
              credits: {
                  enabled: false
              },
              title: '',
              series: [{
                  name: "All",
                  data: this.chartData.seriesData
              }],
              xAxis: {
                  categories: this.chartData.categories,
                  labels: {
                      autoRotation: false,
                      style: {
                          fontSize: '10px'
                      }
                  }
              },
              yAxis: {
                labels: {
                    style: {
                        fontSize: '20px'
                    }
                },
                title: {
                    text: 'Responses'
                }
            },
            tooltip: {
                enabled: false
            },
            legend: {
                enabled: false
            }
          },
          responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    xAxis: {
                        autoRotation: false,
                        labels: {
                            style: {
                                fontSize: '5px'
                            }
                        }
                    },
                }
            }]
    }
      }
  }
}
</script>
<style scoped>
#feedback {
    border-radius: 5px;
    padding: 15px;
    background-color: #def0d7;
    color: #376328;
}
@media (max-width: 640px) {
    #poll {
        width: 100% !important;
    }
    #poll div {
        overflow: visible !important;
    }
    .feedback {
        margin-top: 30px;
    }
}
</style>